import {Component, EventEmitter, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../services/Toast.service";
import {NumeralService} from "../../services/Numeral.service";
import {StateService} from "../../services/StateService";
import {SwitchBoard} from "../../services/SwitchBoard";
import {ActivatedRoute, Router} from "@angular/router";
import {LoadingService} from "../../services/LoadingService";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {State} from "../../models/State";
import {PageTitleService} from "../../services/PageTitle";
import {Session} from "../../services/Session";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {FormatAmountPipe} from "../../pipes/format-amount.pipe";
import {HighchartsChartModule} from "highcharts-angular";
import * as Highcharts from 'highcharts';
import {StatusTrackerComponent} from "../status-tracker/status-tracker.component";
import {QuestionnairesSurveysService} from "../../services/questionnaires-surveys.service"
import { CustomerDashboardTodosComponent } from './todos/customer-dashboard-todos.component';

declare const _: any;

@Component({
  selector: 'app-customer-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, FormatAmountPipe,  HighchartsChartModule, StatusTrackerComponent, CustomerDashboardTodosComponent],
  templateUrl: './customer-dashboard.component.html',
  styleUrl: './customer-dashboard.component.scss',
   encapsulation: ViewEncapsulation.None,
})
export class CustomerDashboardComponent implements OnInit, OnDestroy {
  taxPlanningStatus: Array<any> = [];
  strategiesWithoutTasks: Array<any> = [];
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  showMessage = false;
  org: string;
  user: any = {};
  statusArray: Array<any> = [
    {status: 'Assigned', date: ''},
    {status: 'Blocked', date: ''},
    {status: 'In Progress', date: ''},
    {status: 'Review', date: ''},
    {status: 'Done', date: ''}
  ];
  groupedTotalTaxSavingsByStrategyChartOptions: any;
  chartColors: Array<any> = ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'];
  filterYears: Array<any> = [];
  yearFilter: any;
  //views: Array<any> = [{name: 'Category'}, {name: 'Related Party'}, {name: 'Strategy'}];
  views: Array<any> = [];
  currentView = '';
  hasTotalSavingsByStrategyData = false;
  totalSavingsData: Array<any>;
  pieChartGraphName = '';
  hasGraphData: boolean;
  totalTaxSavings = 0;
  showQuestionnaire=false;
  Highcharts: typeof Highcharts = Highcharts;

  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private titleService: PageTitleService,
    private taxPlanningService: TaxPlanningService,
    private numeralService: NumeralService,
    private stateService: StateService,
    private _router: Router,
    private _route: ActivatedRoute,
    private switchBoard: SwitchBoard,
    private qsService: QuestionnairesSurveysService
  ) {}

  ngOnInit(): void {
    this.org = Session.getOrg();
    this.user = Session.getUser('delegatedFrom').id;
    this._init();
  }

  _init(){
    const base = this;
    this.titleService.setPageTitle('Dashboard');
    this.switchBoard.onCustomerLogin.next({});
    this.getDefaultPlanInfo();
    this.getQuestionaire();
  }
   
  getQuestionaire(){
    this.qsService.getQuestionnaireDetails(this.org, this.user).subscribe(questionnaire => {
      this.showQuestionnaire=questionnaire.showQuestionnaire ;
    }, error => {});
  }

  getDefaultPlanInfo() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getClientDefaultPlansInfo(this.org, this.user, this.user)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        const allYearsOption = { name: 'All', id: 'all' };
        const yearsWithAllOption = [allYearsOption, ...response.publishedYears];
        this.filterYears = yearsWithAllOption;

        if(response.publishedViews){
          const publishedViews: string[] = response.publishedViews;
          this.views = publishedViews.map(view => ({ name: view }));
        }
        this.currentView = response.defaultView;
       
        if (this.filterYears.length > 0) {
          //const yearObject = _.maxBy(this.filterYears, function(year) { return year.id; });
          const yearObject = _.maxBy(this.filterYears.filter(y => y.id !== 'all'), year => year.id);
          const prevState = this.stateService.getPrevState();
          if (prevState && prevState.data) {
            this.stateService.pop();
            this.yearFilter = (prevState.data.year) ? prevState.data.year : yearObject.id;
            this.currentView = (prevState.data.view) ? prevState.data.view : this.currentView;
          } else {
           // this.yearFilter = yearObject.id;
            const currentYear = new Date().getFullYear().toString();
            const previousYear = (parseInt(currentYear) - 1).toString();
              const currentExists = this.filterYears.find(item => item.id === currentYear);
              const previousExists = this.filterYears.find(item => item.id === previousYear);

              if (currentExists) {
                this.yearFilter = currentYear;
              } else if (previousExists) {
                this.yearFilter = previousYear;
              } else {
                this.yearFilter = 'all';
              }
          }
          this.getPieChartData();
        } else {
          this.showMessage = true;
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Default Plan Info');
      });
  }

  formatTaskStrategies(strategies) {
    const base = this;
    const strategiesWithTask = [];
    const strategiesWithoutTasks = [];
    if (strategies.length > 0) {
      _.each(strategies, function(strategy){
        if (strategy.allStatus && strategy.allStatus.length > 0) {
          strategiesWithTask.push(strategy);
        } else {
          strategiesWithoutTasks.push(strategy);
        }
      });
    }
    this.taxPlanningStatus = strategiesWithTask;
    this.strategiesWithoutTasks = strategiesWithoutTasks;
    this.formatStatusData();
  }

  getPieChartData() {
    const base = this;
    let graphName = '';
    let yearText = this.yearFilter === 'all' ? '' : `${this.yearFilter} `;
    if (this.currentView === 'Strategy') {
      graphName = 'Total Published ' + (yearText) + ' Tax Savings By Strategy';
    } else if (this.currentView === 'Related Party') {
      graphName = 'Total Published ' + (yearText) + ' Tax Savings By Related Party';
    } else if(this.currentView === 'Category'){
      graphName = 'Total Published ' + (yearText) + ' Tax Savings By Category';
    }
    this.pieChartGraphName = graphName;
    this.loadingService.triggerLoadingEvent(true);
    let year = this.yearFilter === 'all'? '': this.yearFilter;
    this.taxPlanningService.getCustomerDashboardPieChartData(this.org, this.user, this.currentView, year)
        .subscribe(metricData => {
        this.hasTotalSavingsByStrategyData = true;
        this.totalSavingsData = metricData.data || [];
        this.totalTaxSavings = metricData.total || 0;
        const taskStrategies = metricData.tasks || [];
        this.formatTaskStrategies(taskStrategies);
        if (this.totalSavingsData && this.totalSavingsData.length > 0) {
          this.hasGraphData = true;
          this.showMessage = false;
        } else {
          this.showMessage = true;
        }
        this.groupedTotalTaxSavingsByStrategyChartOptions = {
          colors: this.chartColors,
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            custom: {},
            style: {
              fontFamily: 'Poppins-Regular',
              fontWeight: '400'
            },
            events: {
              render: function () {
                const chart = this;
                let series = chart.series[0];
                let customLabel = chart.options.chart.custom.label;
                 // Create the label only once
                if (!customLabel) {
                  customLabel = chart.options.chart.custom.label =
                        chart.renderer.label(
                            'Total Savings  <br/>' +
                            '<strong>'+base.formatAmount(base.totalTaxSavings)+'</strong>'
                        )
                            .css({
                                color: '#000',
                                textAnchor: 'middle'
                            })
                            .add();
                }
                const x = series.center[0] + chart.plotLeft,
                y = series.center[1] + chart.plotTop -
                (customLabel.attr('height') / 2);

            customLabel.attr({
                x,
                y
            });
            // Set font size based on chart diameter
            customLabel.css({
                fontSize: `${series.center[2] / 12}px`
            });
            }
            }
          },
          title: {
            text: '',
            align: 'left',
            style: {
              color: '#878787',
              fontFamily: 'Poppins-Regular',
                   fontWeight: '300',
              fontSize: '24'
            }
          },
          subtitle: {
            text: ''
          },
          credits: {
            enabled: false
          },
          legend: {
            enabled: true,
            // align: 'right',
            floating: true,
            verticalAlign: 'middle',
            layout: 'vertical', 
            itemMarginTop: 10, // spacing *between items* (top)
             itemMarginBottom: 10,// spacing *between items* (bottom)
            x: 310,
          },
          plotOptions: {
            pie: {
              events: {
                click(event) {
                  base.showOverview(event.point.name);
                }
              },
              center: ['32%', '50%'], // Move the pie chart to the left
            },
            series: {
              showInLegend: true,
          }
          },
          tooltip: {
            pointFormatter(){
              return '<b>Total: ' + base.formatAmount(this.y) + '</b><b>(' + base.getFormattedPercentage(this.percentage) + '%)</b>';
            }
          },
          pie: {
            dataLabels: {
              enabled: true,
              inside: true,
              formatter(){
                return this.y;
              },
              distance: -40,
              color: 'white'
            },

          },
          series: [{
            colorByPoint: true,
            innerSize: '75%',
            data: base.getOpexData(metricData.data)
          }]
        };
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.showMessage = true;
        this.toastService.pop(TOAST_TYPE.error, 'Failed To get Tax Savings Data.');
      });
  }

  showOverview(plotName) {
    if (this.currentView == 'Strategy' && this.totalSavingsData.length > 0) {
      const object = _.find(this.totalSavingsData, {name: plotName});
      if (object && object.lineId) {
        this.navigateStrategySinglePage(object.lineId);
      }
    }
  }

  navigateStrategySinglePage(strategyId) {
    const data = {
      year: this.yearFilter,
      view: this.currentView,
    };
    this.stateService.addState(new State('TP_CUSTOMER_DASHBOARD', this._router.url, data, null));
    this._router.navigate(['tax-planning', 'strategy-overview', strategyId]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFormattedPercentage(value){
    return this.numeralService.format('0,0', value);
  }

  formatAmount(amount){
    return this.numeralService.format('$0,0', amount);
  }
  getOpexData(data){
    const result = [];
    _.each(data, function(valueObj){
      result.push({
        name: valueObj.name,
        y: valueObj.savings
      });
    });
    return result;
  }

  formatStatusData() {
    const base = this;
    _.each(base.taxPlanningStatus, function(status){
      const tempArray = [];
      _.each(base.statusArray, function(statusObj){
        const markedStatus = _.find(status.allStatus, {status: statusObj.status});
        if (markedStatus){
          tempArray.push({
            status: statusObj.status,
            date: markedStatus.date
          });
        } else {
          tempArray.push({
            status: statusObj.status,
            date: ''
          });
        }
      });
      status.allStatus = tempArray;
    });
  }

  showTaskOverview(status) {
    this.navigateStrategySinglePage(status.lineId);
  }

  setYear($event) {
    this.yearFilter = $event.id;
    this.getPieChartData();
  }

  setGraphType($event) {
    this.currentView = $event.name;
    this.loadingService.triggerLoadingEvent(true);
    this.getPieChartData();
  }

}
